import { useState, useEffect } from 'react';
import 'intersection-observer';
const defaultVisibilityThreshold = 0.5;
const useInView = (target, options = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    root,
    rootMargin,
    threshold = defaultVisibilityThreshold
  } = options;
  const rootElement = root && root.current;
  useEffect(() => {
    if (target.current) {
      const observer = new IntersectionObserver(([entry]) => setIsVisible(entry && entry.intersectionRatio > threshold), {
        root: rootElement,
        rootMargin,
        threshold
      });
      observer.observe(target.current);
      return () => observer.disconnect();
    }
    return undefined;
  }, [target.current, threshold, rootElement, rootMargin]);
  return isVisible;
};
export default useInView;